(() => {
  angular.module('finance').component('subscriptionInvoiceDetailComponent', {
    templateUrl: require('./subscriptionInvoiceDetail.component.html'),
    controller: SubscriptionInvoiceDetailComponent,
    controllerAs: 'vm',
    bindings: {
      currencyCode: '<',
      invoice: '<',
      invoiceFrom: '<',
      invoiceTo: '<',
      isAddressInvoiceFrom: '<',
      isAddressInvoiceTo: '<',
      message: '<',
      getDateString: '<'
    },
  });

  SubscriptionInvoiceDetailComponent.$inject = [];

  function SubscriptionInvoiceDetailComponent() {
    const vm = this;

    vm.loading = 0;

    init();

    function init() {}
  }
})();
